<template>
  <div class="container">
    <h4 v-if="defaultQuery">{{ tableConfig.tableName }}</h4>
    <div v-if="defaultQuery" class="selection">
      <slot name="searchConditions"></slot>
      <slot name="searchActions"></slot>
    </div>
    <a-table
      v-show="defaultQuery && !isSearchEmpty"
      row-key="id"
      :locale="locale"
      :columns="tableConfig.tableColumns"
      :data-source="data"
      :scroll="{ y: tableHeight }"
      @change="handleTableChange"
    >
      <template v-for="(value, key) in $scopedSlots" :slot="key" slot-scope="text, record">
        <slot :name="key" :text="text" :record="record"></slot>
      </template>
      <template slot="operate" slot-scope="text, record">
        <div class="operate">
          <a-button type="link" style="padding-right: 0" @click="defaultEdit(record)">
            编辑
          </a-button>
          <a-button type="link" v-if="!record.isAdmin" style="padding-left: 0" @click="delModal(record.id)">
            删除
          </a-button>
        </div>
      </template>
    </a-table>
    <div v-show="!(defaultQuery && !isSearchEmpty)" class="nodata">
      <img src="@/assets/img/bj_zanwu_2.png" v-if="isDefaultSearch" alt="" />
      <img :src="emptyImgSrc" v-else alt="" />
      <div>
        <div class="text">{{ emptyText }}</div>
        <slot name="serchTip" v-if="isSearchEmpty"></slot>
        <slot name="create" v-else-if="!isSearchEmpty && (!isStudent || showCreateBtn)"></slot>
        <slot name="search" v-else-if="!isSearchEmpty && isStudent"></slot>
      </div>
    </div>
    <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handlePaginationChange" />
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `
        <p>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.title}</p>
        <p class='placeholder'>${tableConfig.tableDeleteTip && tableConfig.tableDeleteTip.content}</p>`
      "
    />
  </div>
</template>

<script>
import { request } from '@/utils/request'
import cookie from 'js-cookie'
import debounce from 'lodash.debounce'
import { getListIndex } from '@/utils/other'
import { nameMap } from '@/utils/map'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Empty from '@/components/Empty/index.vue'
import { areAllValuesEmptyOrUndefinedOrNull } from '@/utils/util'

export default {
  props: {
    tableConfig: {
      type: Object,
      default: () => ({})
    },
    searchParams: {
      type: Object,
      default: () => ({})
    },
    emptyText: {
      type: String,
      default: function () {
        return this.$t('noDataEmpty')
      }
    },
    emptyImgSrc: {
      type: String,
      default: require('@/assets/img/bj_zanwu@2x.png')
    },
    showCreateBtn: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TipModal,
    Pagination
  },
  data() {
    return {
      passwordFlag: false,
      passwordModal: false,
      repasswordFlag: false,
      oldpasswordFlag: false,
      passwordConfirmLoading: false,
      aboutVisible: false,
      delId: undefined,
      delVisible: false,
      data: [],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: this.$form.createForm(this),
      user: cookie.getJSON('user_infor'),
      isDefaultQuery: true,
      isDefaultSearch: false,
      search: debounce(this.debouncedSearch, 500),
      locale: {
        emptyText: <Empty />
      },
      tableHeight: 0,
      isStudent: cookie.get('user_type') && JSON.parse(cookie.get('user_type')).includes('student'),
      listPostArr: ['/ai/dataset/list']
    }
  },
  computed: {
    defaultQuery() {
      return !(this.pagination.total === 0 && this.isDefaultQuery)
    },
    customSlots() {
      return this.tableConfig.tableColumns.filter(item => item.customSlots)
    },
    isSearchEmpty() {
      if (this.$route.meta.permission.includes('admin')) return false
      return this.pagination.total === 0 && this.isDefaultSearch
    }
  },
  watch: {
    searchParams: {
      deep: true,
      handler(val) {
        this.search(val)
        this.isDefaultQuery = false
        this.isDefaultSearch = true
        if (areAllValuesEmptyOrUndefinedOrNull(val)) {
          this.clearCache()
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.user = cookie.getJSON('user_infor')
    })
  },
  methods: {
    debouncedSearch(searchParams) {
      this.pagination.page = 1
      this.getList({ searchParams })
    },
    handlePaginationChange() {
      this.getList()
    },
    defaultEdit(record) {
      if (!this.tableConfig.tableEditRouteNName) {
        this.$message.error('请配置tableEditRouteNName')
      }
      this.$router.push({
        name: this.tableConfig.tableEditRouteNName,
        query: {
          id: record.id
        }
      })
    },
    delModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      request({
        url: '/api' + this.tableConfig.tablePort.del,
        method: 'post',
        data: { id: this.delId }
      }).then(res => {
        if (res.code === 200) {
          this.delVisible = false
          this.pagination.page = 1
          this.getList({})
          this.$message.success('删除成功！')
        }
      })
    },
    /**
     * 获取列表数据
     *
     * @param {object} params 获取列表的参数
     * @param {object} params.searchParams 搜索参数
     * @param {object} params.condition 其他条件参数
     */
    getList(searchCondition = {}) {
      // 解构searchCondition对象，获取searchParams和condition属性
      const { searchParams, condition } = searchCondition
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        ...(searchParams ? searchParams : this._searchParams),
        ...(condition ? condition : this._condition)
      }
      // 缓存查询条件
      this._condition = condition ? condition : this._condition
      this._searchParams = searchParams ? searchParams : this._searchParams
      // 过滤掉空值
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== '' && value !== null && value !== undefined)
      )
      if (this.listPostArr.includes(this.tableConfig.tablePort.list)) {
        request({
          url: '/api' + this.tableConfig.tablePort.list,
          method: 'post',
          data: filteredParams
        }).then(res => {
          if (res.code === 200) {
            this.data = getListIndex(
              nameMap(res.data.list, this.tableConfig.tablePort.list),
              this.pagination.page,
              this.pagination.pageSize
            )
            this.pagination.total = Number(res.data.total)
          }
        })
      } else {
        request({
          url: '/api' + this.tableConfig.tablePort.list,
          method: this.tableConfig.tablePort.listMethod || 'get',
          params: filteredParams
        }).then(res => {
          if (res.code === 200) {
            this.data = getListIndex(
              nameMap(res.data.list, this.tableConfig.tablePort.list),
              this.pagination.page,
              this.pagination.pageSize
            )
            this.pagination.total = Number(res.data.total)
          }
        })
      }
    },
    handleTableChange(p, filters, sort) {
      this.isDefaultQuery = false
      this.isDefaultSearch = false
      this.$emit('tableChange', [filters, this.getList, sort])
    },
    getTableHeight() {
      const container = document.querySelector('.container')
      setTimeout(() => {
        if (container.children[0].tagName === 'H4' && container.children[0].innerText) {
          console.log('H4 ----->')
          this.tableHeight = window.innerHeight - 290
        } else {
          console.log('H4 <-----')
          if (this.$route.name === 'repositoryFileDetails') {
            this.tableHeight = window.innerHeight - 303
          } else {
            this.tableHeight = window.innerHeight - 280
          }
        }
      }, 500)
    },
    clearCache() {
      if (this._condition) {
        this.isDefaultQuery = false
        this.isDefaultSearch = false
      }
    }
  },
  mounted() {
    if (this.tableConfig.tableData && this.tableConfig.tableData.length > 0) {
      this.data = this.tableConfig.tableData
      this.pagination.total = this.tableConfig.tableData.length
    } else {
      this.getList({ searchParams: this.searchParams, condition: this.condition })
    }
    this.getTableHeight()
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  padding-top: 20px;
  padding-bottom: 30px;
  /deep/ .ant-table {
    /// min-height: 583px;
    .ant-table-tbody > tr > td {
      height: 65px;
    }
  }
  position: relative;
  .list-pagination {
    position: absolute;
    // bottom: 50px;
    width: calc(100% - 44px);
  }
}
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
.selection {
  display: flex;
  flex-wrap: wrap;
  margin: 22px 0px;
  justify-content: space-between;
  /deep/.ant-input,
  /deep/ .ant-select-selection,
  /deep/.ant-input-affix-wrapper {
    width: 237px;
    height: 35px;
    color: #000;
    margin-right: 30px;
    border-radius: 20px;
    .ant-input-prefix,
    .ant-input-suffix {
      > img {
        width: 16px;
        cursor: pointer;
      }
    }
    .ant-input-suffix .clear {
      width: 14px;
      height: 14px;
    }
  }
}
.nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 50vh;
  transform: translateY(-200px);
  img {
    width: 285px;
    margin-bottom: 12px;
  }
  > div {
    width: 100%;
    display: flex;
    margin-top: -48px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .text {
      font-weight: 550;
      color: #0d2340;
      margin-bottom: 10px;
    }
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
/deep/.ant-form {
  .ant-form-item {
    margin-bottom: 22px;
    .ant-form-item-label {
      margin-bottom: 6px;
      line-height: normal !important;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
